import { Component, inject, DestroyRef } from '@angular/core';
import { JobsService } from '../../../services/http/admin/jobs.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SHARED_IMPORTS } from '../../../shared/standalone-imports';

@Component({
    selector: 'app-admin-jobs',
    templateUrl: './admin-jobs.component.html',
    styleUrls: ['./admin-jobs.component.less'],
    imports: [SHARED_IMPORTS]
})
export class AdminJobsComponent {
  private jobsService = inject(JobsService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** An identifier of a job, which should be retrieved. */
  jobLogId: string;
  /** An identifier of a job, which should be cancelled. */
  jobCancelId: string;
  /** Job logs, retrieved by {@link jobLogId}. */
  jobLog: string;

  /**
   * Retrieves job logs for {@link jobLogId} from backend.
   */
  getJobLog() {
    this.jobsService.getJobLog(this.jobLogId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: res => this.jobLog = res
      });
  }

  /**
   * Cancels the running job by {@link jobCancelId} in backend.
   */
  cancelJob() {
    this.jobsService.cancelJob(this.jobCancelId)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
}
